<script>
export default {
  template: `<div class="has-text-centered">
    <button class="button is-dark is-small" v-on:click="toggleDependencies()">
        <span v-tooltip="show ? 'Ocultar dependencias' : 'Mostrar dependencias'" class="icon">
          <i class="material-icons">{{show ? 'visibility' : 'visibility_off'}}</i>
        </span>
    </button>
  </div>`,
  data(){
    return {
      show: false
    }
  },
  methods:{
    // Actions
    toggleDependencies(){
      const allColumns = this.params.columnApi.getAllColumns();
      this.show = !this.show

      // Ocultar columnas que tienen el field 'dependencias'
      allColumns.forEach((column) => {
        if (column.getColDef().field === 'dependencias') {
          this.params.columnApi.setColumnVisible(column, this.show);
        }
      });
    }
  }
}
</script>

<style lang='scss'>
</style>



// WEBPACK FOOTER //
// src/components/lideres/components/headerDependLeader.vue